import Checkbox from "../../../Common/Forms/Checkbox";

interface IEngagementPanelCheckbox {
  checked: boolean;
  label: string;
  onChange?: any;
}

//TODO: Allow unlimited changes on client side, THEN update backend post click to give user 'immediate' feel
export default function EngagementPanelCheckbox(
  props: IEngagementPanelCheckbox
) {
  return (
    <div className="inline-flex flex-row items-center justify-start gap-3 p-1">
      <Checkbox checked={props.checked} onChange={props.onChange} />
      <p className="text-normal text-brij-Default inline leading-[1.5]">
        {props.label}
      </p>
    </div>
  );
}
